// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","368":"confirm","511":"cart","637":"order","845":"profile"}[chunkId] + "." + {"18":"c2c03e0a","368":"9134bf34","511":"272e4818","637":"bd48c099","845":"fb71813a"}[chunkId] + ".js";
};